module.exports = {
  GuideTagDisplay: {
    PluginName: "Ekran Eğitimi Etiket Gösterimi",
    Tag: "Etiket",
    tagRef: "Etiket referansı",
  },
};
